<template>
    <div id="person-center">
        <Content class="content-wrap">
            <ul class="nav-tabs">
                <li class="tab-top">个人中心</li>
                <li class="tab-item"  @click="selectTab(item,index)" :class="[{active:currentTabIndex==index},item.icon]" v-for="(item,index) in tabs" :key="index">{{item.name}}</li>
            </ul>
            <ul class="tabs-content">
                <li class="top-info">
                    <div class="tab-title">{{currentTabName}}</div>
                    <!--<div class="login-date">登录时间：2017-09-09 13:12:09</div>-->
                </li>
                <li v-show="currentTabIndex==0"><personInfo @toLogOut="toLogout"></personInfo></li>
                <li v-show="currentTabIndex==1"><creatMemorial></creatMemorial></li>
                <li v-show="currentTabIndex==2"><sacrificeManage ref="sacrificeManage"></sacrificeManage></li>
                <li v-show="currentTabIndex==4"><orderList ref="orderList" @toInfo="toInfo"></orderList></li>
            </ul>
        </Content>
        <fx-modal ref="logoOutConfirm" :title="plugin.modal.toLogout.title" @closeModal="closeModal('toLogout')" :contentText="plugin.modal.toLogout.desc" @ok="confirm('toLogout')" ></fx-modal>
        <fx-modal ref="createMemorialConfirm" :title="plugin.modal.createMemorial.title" @closeModal="closeModal('createMemorial')" :contentText="plugin.modal.createMemorial.desc" @ok="confirm('createMemorial')" ></fx-modal>
    </div>
</template>

<script>
    import personInfo from './personInfo'
    import creatMemorial from './creatMemorial'
    import sacrificeManage from './sacrificeManage'
    import orderList from '../order/list'
    import  fxModal from '../../components/fx-modal'
    import {mapState,mapActions} from 'vuex'
    export default {
        name: 'personCenter',
        components: {
            personInfo,
            creatMemorial,
            sacrificeManage,
            orderList,
            fxModal
        },
        data(){
            return{
                orderId:'',
                currentTabIndex:0,
                currentTabName:'个人信息',
                tabs:[{
                    name:'个人信息',
                    icon:'person'
                },{
                    name:'',
                    icon:'memorial'
                },{
                    name:'祭扫管理',
                    icon:'manage'
                },{
                    name:'查看纪念馆',
                    icon:'look'
                },{
                    name:'我的预约',
                    icon:'order',
                },{
                    name:'退出登录',
                    icon:'logout'
                }],
                plugin:{
                    modal:{
                        toLogout:{
                            title:'退出登录?',
                            desc:'是否退出登录？'
                        },
                        createMemorial:{
                            title:'新建纪念馆?',
                            desc:'是否新建纪念馆？'
                        }
                    }
                }
            }
        },
        created(){
        },
        activated(){
            if(!this.token) {
                this.toLogout()
            }
            this.currentTabIndex = 0
            this.updateMemorialInfo()
        },
        watch:{
            userMemorialId(id){
                if(id){
                    this.updateMemorialInfo()
                }
            }
        },
        computed:{
            ...mapState(['token','userMemorialId'])
        },
        methods:{
            ...mapActions(['logout']),
            updateMemorialInfo(){
                if(this.userMemorialId){
                    this.tabs[1].name='修改纪念馆'
                }else{
                    this.tabs[1].name='我要建纪念馆'
                }
            },
            closeModal(key){
                // this.plugin.modal[key].fade= false
                this.$refs[key].hide()
            },
            openModal(key){
                // this.plugin.modal[key].fade= true
                this.$refs[key].open()
            },
            confirm(key){
                if(key=='toLogout'){
                    this.toLogout()
                }
                if(key=='createMemorial'){
                    this.currentTabIndex = 1
                }
            },
            toLogout(){
                console.log('退出')
                this.logout()
                this.$router.push({
                    path: `/home/`
                })
                window.location.reload()
            },
            selectTab(item,index){
                this.currentTabIndex = index;
                this.currentTabName = item.name;
                if(index==2){
                    this.$refs.sacrificeManage.getGrieveList()
                }
                if(index==3){
                    if(this.userMemorialId){
                        this.toMemorialDetail()
                    }else{
                        this.openModal('createMemorialConfirm')
                    }
                }
                if(index==4){
                    this.$refs.orderList.getOrderList()
                }
                if(index==5){
                    this.openModal('logoOutConfirm')
                }
            },
            toMemorialDetail(){
                this.$router.push({
                    path: `/memorialDetail/${this.userMemorialId}`
                })
            },
            toInfo(id){
                this.$router.push({name:'orderInfo',params:{id:id}})
            }
        }
    }
</script>

<style scoped lang="scss">
    #person-center{
        background-color: #F9F9F9;
    }
    .content-wrap{
        width: 1200px;
        margin: 20px auto;
        padding-bottom: 40px;
        overflow: hidden;
        min-height: 600px;
        // max-height: 950px;
    }
    .nav-tabs{
        float: left;
        font-size: 16px;
        text-align: center;
        width: 230px;
        height: 100%;
        background-color: #fff;
        border: 1px solid #E5E5E5;
        .tab-top{
            height: 60px;
            background-color: #009DE9;
            line-height: 60px;
            color:#FFF;
            font-size: 20px;
        }
        .tab-item{
            height: 50px;
            line-height: 50px;
            font-size: 18px;
            background-size: 40px;
            padding-left: 100px;
            text-align: left;
            &.person{
                background: url('../../assets/images/icon/person.jpg') 40px 10px no-repeat;
            }
            &.memorial{
                background: url('../../assets/images/icon/memorial.jpg') 40px 10px no-repeat;
            }
            &.manage{
                background: url('../../assets/images/icon/manage.jpg') 40px 10px no-repeat;
            }
            &.look{
                background: url('../../assets/images/icon/look.jpg') 40px 10px no-repeat;
            }
            &.order{
                background: url('../../assets/images/icon/order_center.png') 45px 15px no-repeat;
            }
            &.logout{
                background: url('../../assets/images/icon/logout.jpg') 40px 10px no-repeat;
            }
            &:hover{
                background-color: #c4dfec52;
                border-color: #009de952;
                cursor: pointer;
            }
            &.active{
                background-color: #009de952;
                border-color: #009DE9;
            }
        }
    }
    .tabs-content{
        background-color: #fff;
        width: 950px;
        height: 100%;
        float: left;
        margin-left: 20px;
        border: 1px solid #E5E5E5;
        padding: 20px 30px;
        .top-info{
            overflow: hidden;
            border-bottom: 1px solid #dcdcdc;
            .tab-title{
                float: left;
                font-size: 20px;
                color: #333;
                padding-bottom: 10px;
                border-bottom: 1px solid #009DE9;
            }
            .login-date{
                float: right;
                font-size: 16px;
                color: #959595;
            }
        }
    }
</style>
